import DataCheck from 'lib/src/components/common/DataCheck';
import Form from '@components/form/Form';
import FormField from 'lib/src/components/form/FormField';
import FormRow from 'lib/src/components/form/FormRow';
import MultiSelect from '@components/form/MultiSelect';
import Modal from '@components/modal/Modal';
import Description from 'lib/src/components/typography/Description';
import { isEmpty } from 'lib/src/utils/generic';
import { Dispatch, SetStateAction } from 'react';
import { ChallengeGroup } from 'src/types/shared/ChallengeGroup';
import useEditChallengeHolder from './hooks/useEditChallengeHolder';

const EditChallengeHolderModal = ({
    challengeGroup,
    setShowEditChallengeHolderModal,
}: EditChallengeHolderModalProps) => {
    const hideModal = () => setShowEditChallengeHolderModal(false);
    const {
        holderOptions,
        isFetching,
        fetchError,
        isPosting,
        handleSubmit,
        handleChange,
        formState,
    } = useEditChallengeHolder(challengeGroup, hideModal);

    return (
        <Modal
            title={`${challengeGroup?.name} Attach Challenge Holder`}
            size="small"
            closeModal={hideModal}
        >
            <Description>Attach a challenge holder for this challenge group.</Description>
            <DataCheck
                dataExists={!isEmpty(challengeGroup)}
                isFetching={isFetching}
                error={fetchError}
            >
                <Form onCancel={hideModal} onSubmit={handleSubmit} isPosting={isPosting}>
                    <FormRow>
                        <FormField name="Challenge Holders">
                            <MultiSelect
                                options={holderOptions}
                                onChange={handleChange}
                                value={formState.challengeHolderIDs}
                                name="challengeHolderIDs"
                                search
                            />
                            <div style={{ marginBottom: '5em' }} />
                        </FormField>
                    </FormRow>
                </Form>
            </DataCheck>
        </Modal>
    );
};

interface EditChallengeHolderModalProps {
    challengeGroup: ChallengeGroup;
    setShowEditChallengeHolderModal: Dispatch<SetStateAction<boolean>>;
}

export default EditChallengeHolderModal;
